// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"6b29c0bd","695":"dfe14486"}[chunkId] + ".chunk.js";
};